/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

//@ts-ignore
import Slider from "react-slick";

import { IWatersportdiscountsSlideContainerViewProps } from './watersportdiscounts-slide-container';




export class WatersportdiscountsSlideContainerView extends React.PureComponent<IWatersportdiscountsSlideContainerViewProps> {

    

    constructor(props: IWatersportdiscountsSlideContainerViewProps) {
        super(props);
        this.state = {
            //nav1: null,
            nav2: null
        };
    }

    componentDidMount() {
        this.setState({
            //@ts-ignore
            //nav1: this.slider1,
            //@ts-ignore
            nav2: this.slider2
        });
      }
    

    public render(): JSX.Element {

        const { 
            
            classNames,
            ctcategories,
            ContentList,
            ContentListItem
            
        } = this.props;

        const settings = {
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        infinite: true,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        return (
            <div className={`slideContainer23 ${classNames}`}>



                <Module {...ContentList}>
                    <Slider
                    
                        //@ts-ignore
                        asNavFor={this.state.nav2}
                        //@ts-ignore
                        ref={slider => (this.slider1 = slider)}
                        //adaptiveHeight={true}
                        
                        {...settings}
                        
                    >

                        { ctcategories.map((ctcategory: ReactNode, index: number) => {
                            return (
                                <Node {...ContentListItem} key={index}>
                                    {ctcategory}
                                </Node>
                            );
                        })}
                    
                    </Slider>
                </Module>

               
            </div>
    
        );
    }
    
};

export default WatersportdiscountsSlideContainerView;
